import React from 'react';

interface BundleWorkIconProps {
  readonly size?: number;
}

/** Basket of ingredients. Matches the Make Bundles pick-view control. */
export function IngredientsIcon({ size = 28 }: BundleWorkIconProps): React.ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M31 3.2h7.2c.7 0 1.2.5 1.2 1.2v4.2c0 .7-.5 1.2-1.2 1.2H36v2.1c3.6 1.3 6.2 4.7 6.2 8.7V26h-16v-5.4c0-4 2.6-7.4 6.2-8.7V9.8h-1.2c-.7 0-1.2-.5-1.2-1.2V4.4c0-.7.5-1.2 1.2-1.2z" />
      <path d="M7.5 20.5c.4-5.2 4.2-8.3 10.4-8.3 2.6 0 4.8.7 6.6 2-2.4 1.5-4 4-4.2 7.1H8.2c-.3 0-.6-.3-.7-.8z" />
      <circle cx="13.2" cy="16.6" r="3.3" />
      <path
        fillRule="evenodd"
        d="M4 23.2h40l-1.6 16.4c-.5 3.6-2.2 5.2-6.4 5.2H12c-4.2 0-5.9-1.6-6.4-5.2L4 23.2zm4.2 3.6h31.6v3.6H8.2V26.8zM10 32.2h3.4v9.2H10v-9.2zm6.2 0H19.6v11.2h-3.4V32.2zm6.2 0h3.4v11.2h-3.4V32.2zm6.2 0h3.4v11.2h-3.4V32.2zm6.2 0H38v9.2h-3.2v-9.2z"
      />
    </svg>
  );
}

/** Sigma in a circle. Totals for every bundle still needed. */
export function TotalIcon({ size = 28 }: BundleWorkIconProps): React.ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="24" cy="24" r="18" stroke="currentColor" strokeWidth="5" />
      <path
        d="M32.5 14.5H18.2l6.6 9.5-6.6 9.5h14.3"
        stroke="currentColor"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
